module.exports = __webpack_public_path__ + "static/media/Segoe UI Bold Italic.268e8929.woff";